import { format } from 'date-fns/fp';
import { pipe } from 'lodash/fp';
import { SHORT_DATE_FORMAT } from '../../constants';
import ensureParseISO from './ensureParseISO';
/**
 * Format date to short format date string
 *
 * @param {(Date | string | number)} dateString - the original date
 *
 * @returns {string} the formatted date string
 *
 * @example
 * formatShortDate(new Date('2018-10-28T23:14')) // returns '2018-10'
 */

export var formatShortDate = pipe(ensureParseISO, format(SHORT_DATE_FORMAT));
export default formatShortDate;